import { render } from "./SelectNameAndJob.vue?vue&type=template&id=65a03024&scoped=true"
import script from "./SelectNameAndJob.vue?vue&type=script&lang=js"
export * from "./SelectNameAndJob.vue?vue&type=script&lang=js"

import "./SelectNameAndJob.vue?vue&type=style&index=0&id=65a03024&lang=less&scoped=true"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a03024"]])

export default __exports__